<script>
    import { kerst } from './stores/2024.store.js';
    import Antwoord from './Antwoord.svelte';
    
</script>

<div id="grid"> 
    {#each $kerst as opgave (opgave.id)}
        <Antwoord id={opgave.id} aantalLetters={opgave.aantalLetters} significant={opgave.significant} />
    {/each}
</div>

<style>
    #grid {
        display: grid;
        grid-template-columns: 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5% 5%;
        margin: auto;
        padding: 2em;
        width: 40em;
    }
</style>